import { GetDynamicInvoiceDataResponseSchema, type DynamicInvoiceIdType, type GetDynamicInvoiceDataResponse } from '@weft/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useDynamicInvoice(id: string, idType: DynamicInvoiceIdType, options?: CustomUseQueryOptions<GetDynamicInvoiceDataResponse>) {
  return useQuery(
    ['dynamicInvoice', id],
    async () => {
      const api = getPrivateApi();
      const getDynamicInvoiceDataResponse = idType === 'Invoice' ? await api.getDynamicInvoice({ invoiceId: id }) : await api.getDynamicInvoiceByCustomer({ customerId: id });

      return GetDynamicInvoiceDataResponseSchema.parse(getDynamicInvoiceDataResponse);
    },
    { suspense: true, ...options },
  );
}